import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { csv } from 'd3-fetch'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { Theme } from '../../styles/settings/theme'
import { Flex, Content } from '../atoms/Basics'
import ChartTitle from '../atoms/ChartTitle'
import ChartContainer from '../atoms/ChartContainer'
import PercentTickAxis from '../atoms/PercentTickAxis'
import LegendColors from '../atoms/LegendColors'
import Subtitle from '../atoms/Subtitle'

const RowFlex = styled(Flex)`
  align-items: center;
  margin: 0 1rem 0.75rem;
`
const Label = styled.div`
  color: ${(props) => props.theme.colors.gray};
  margin: 0 1rem 0 0;
  //min-width: 16rem;
  width: 17rem;
  font-size: ${(props) => props.theme.fontSizes[0]};
  font-weight: 600;
  text-align: right;
  ${Mq.md} {
    font-size: 12px;
    width: 11rem;
  }
  ${Mq.sm} {
    font-size: 11px;
    width: 9rem;
  }
  ${Mq.xs} {
    font-size: 10px;
    width: 7.5rem;
  }
`
const BaseBar = styled.div`
  flex: 1;
  height: 2.25rem;
  background-color: ${(props) => props.theme.colors.gray0};
  position: relative;
`
const RankBar = styled.div`
  position: absolute;
  top: 0;
  left: ${(props) => props.left}%;
  background-color: ${(props) => props.color};
  height: 2.25rem;
  width: ${(props) => props.width}%;
`

const TickContainer = styled.div`
  flex: 1;
  position: relative;
  height: 7rem;
`

const Challenges = () => {
  const $ = window.WILDLABS_VARS
  const [data, setData] = useState(null)
  useEffect(() => {
    csv('./data/challenges.csv').then((data) => {
      setData(data)
    })
  }, [])
  const colors = [
    Theme.colors.darkOrange,
    Theme.colors.mediumOrange,
    Theme.colors.lightOrange,
    Theme.colors.gray5,
    Theme.colors.gray4,
    Theme.colors.gray3,
    Theme.colors.gray2,
    Theme.colors.gray1,
    Theme.colors.gray0
  ]

  const allBars = [
    $.challenges_columns.First,
    $.challenges_columns.Second,
    $.challenges_columns.Third,
    $.challenges_columns.Fourth,
    $.challenges_columns.Fifth,
    $.challenges_columns.Sixth,
    $.challenges_columns.Seventh,
    $.challenges_columns.Eighth
    //CHALLENGES_COLUMNS.Ninth -- not showing this just lets remainder be base bar color (so you won't see bar that adds up to over 100)
  ]

  //gets array of column names to sum
  const bars = (i) => {
    return allBars.slice(0, i)
  }

  //sums all previous bars to find starting point of new bar
  const calcValue = (i, row) => {
    const colsToSum = bars(i)
    return colsToSum.reduce((acc, curr) => {
      return acc + +row[curr]
    }, 0)
  }

  const dataSorted = data?.sort((a, b) => {
    return a[$.challenges_columns.Tenth] - b[$.challenges_columns.Tenth]
  })
  return (
    <ChartContainer>
      <ChartTitle text={$.challenges_titles.chartTitle} />
      <Content flexDirection="column">
        <RowFlex justifyContent="space-between">
          <LegendColors colors={colors} columns={data?.columns.slice(1)} />
        </RowFlex>
        <RowFlex>
          <Label></Label>
          <TickContainer>
            <Flex justifyContent="center">
              <Subtitle
                text={$.challenges_titles.subtitle}
                size={Theme.fontSizes[2]}
                color={Theme.colors.gray}
              ></Subtitle>
            </Flex>
            <PercentTickAxis />
          </TickContainer>
        </RowFlex>
        {dataSorted?.map((row, i) => (
          <RowFlex key={row.challenge}>
            <Label>{row.challenge}</Label>
            <BaseBar>
              {colors.map((color, i) => (
                <RankBar
                  key={`${color} + i`}
                  color={color}
                  left={calcValue(i, row) * 100}
                  width={allBars[i] ? row[allBars[i]] * 100 : 0}
                ></RankBar>
              ))}
            </BaseBar>
          </RowFlex>
        ))}
      </Content>
    </ChartContainer>
  )
}

export default Challenges
